import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Libri San Pietro';
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/app.component.ts